import { render, staticRenderFns } from "./serviceChild.vue?vue&type=template&id=371977c6&scoped=true&"
import script from "./serviceChild.vue?vue&type=script&lang=js&"
export * from "./serviceChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371977c6",
  null
  
)

export default component.exports